require('roc-slot/spingames');
require('roc-slot/common/feature-freespin');

require('./js/primary.js');

require('./js/allWilds.js');
require('./js/bg_hider.js');
require('./js/hide_trigger.js');
require('./js/indicators.js');
require('./js/konami_fallback.js');
require('./js/sound_switch.js');
require('./js/toggle.js');

require('./css/game.css');
require('./css/desktop.css');
require('./css/mobile.css');
require('./css/hider.css');



/** WEBPACK FOOTER **
 ** ./public-src/game.js
 **/